import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnChanges,
	ElementRef, AfterViewInit
} from '@angular/core';

import { TopoMap, DisplayEdge, DashStyle } from '../../dtos/topology/TopoMap';

@Component({
    selector: 'pen-pattern-editor',
	templateUrl: './pen-pattern-editor.component.html',
	styleUrls: ['./pen-pattern-editor.component.scss']
})
export class PenPatternEditorComponent implements AfterViewInit, OnChanges {

	@Input()
	public lineColor: string;
	@Output()
	public lineColorChange: EventEmitter<string>;

	@Input()
	public lineWidth: number;
	@Output()
	public lineWidthChange: EventEmitter<number>;

	@Input()
	public lineDashStyle: string;
	@Output()
	public lineDashStyleChange: EventEmitter<string>;

	public lineWidthOptions: any[];
	public lineDashStyleOptions: any[];


	constructor(private elementRef: ElementRef) {

		this.lineColor = "#000000";
		this.lineColorChange = new EventEmitter<string>();

		this.lineWidth = 1;
		this.lineWidthChange = new EventEmitter<number>();

		this.lineDashStyle = "Solid";
		this.lineDashStyleChange = new EventEmitter<string>();

		this.lineWidthOptions = [
			{ label: "1", value: 1 },
			{ label: "2", value: 2 },
			{ label: "3", value: 3 },
			{ label: "4", value: 4 }
		];
		this.lineDashStyleOptions = [
			{ label: "Solid", value: "Solid" },
			{ label: "Dash", value: "Dash" },
			{ label: "Dot", value: "Dot" },
			{ label: "DashDot", value: "DashDot" },
			{ label: "DashDotDot", value: "DashDotDot" }
		];
	}

	public ngAfterViewInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public onLineColorChange(event): void {
		this.lineColorChange.emit(this.lineColor);
	}

	public onLineWidthChange(event): void {
		this.lineWidthChange.emit(this.lineWidth);
	}

	public onLineDashStyleChange(event): void {
		this.lineDashStyleChange.emit(this.lineDashStyle);
	}

}